import React from "react";

/**
 * Texto de aviso com `**negrito**` e quebra de linha.
 *
 * Monta nós de React em vez de injetar HTML (`dangerouslySetInnerHTML`): o texto vem de um campo
 * editável, e injetar HTML ali abriria a porta para script no cartão que todo mundo vê na entrada
 * do sistema. Aqui o pior que alguém consegue escrever é um asterisco perdido.
 *
 * Suporta só o que o pessoal usa escrevendo: negrito e linhas. Lista e link ficam de fora até
 * alguém precisar — formatação demais num cartão de 3:1 vira poluição.
 */
export default function TextoRico({ texto, className = "" }) {
  if (!texto) return null;

  const linhas = String(texto).split(/\r?\n/);

  return (
    <span className={className}>
      {linhas.map((linha, indiceLinha) => (
        <React.Fragment key={`linha-${indiceLinha}`}>
          {indiceLinha > 0 ? <br /> : null}
          {/* O split com grupo de captura devolve o conteúdo entre ** nos índices ímpares. */}
          {linha.split(/\*\*(.+?)\*\*/g).map((parte, indiceParte) => (
            indiceParte % 2 === 1
              ? <strong key={`forte-${indiceLinha}-${indiceParte}`} className="font-semibold">{parte}</strong>
              : <React.Fragment key={`texto-${indiceLinha}-${indiceParte}`}>{parte}</React.Fragment>
          ))}
        </React.Fragment>
      ))}
    </span>
  );
}
